import { render, staticRenderFns } from "./StaleSession.vue?vue&type=template&id=29de7163&scoped=true&lang=pug"
import script from "./StaleSession.vue?vue&type=script&lang=ts"
export * from "./StaleSession.vue?vue&type=script&lang=ts"
import style0 from "./StaleSession.vue?vue&type=style&index=0&id=29de7163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29de7163",
  null
  
)

export default component.exports